module.exports = __webpack_public_path__ + "static/royals-d1f06e3dc724f6fc09dfd00ca150d9ff.jpg";